<template>
  <header class="navbar d-flex">
    <button
      ref="menuButton"
      type="button"
      class="navbar-menu-toggle"
      aria-controls="primary-navigation"
      :aria-expanded="navigationOpen"
      :aria-label="$t('navigation.open_menu')"
      @click="onToggleNavigation"
    >
      <i class="bx bx-menu" aria-hidden="true"></i>
    </button>
    <router-link to="/dashboard" class="navbar-mobile-brand" aria-label="Destinatarium">
      <img src="@/assets/images/logo-destinatarium-70.png" alt="" />
      <span>Destinatarium</span>
    </router-link>
    <div class="float-end w-100 nav-user-menu">
      <div class="d-flex profile justify-content-end align-items-center flex-end">
        <div class="d-flex notification text-yellow">
          <router-link
            to="/notifications"
            class="notification-link"
            :class="{ 'has-unread': unreadCount > 0 }"
            :aria-label="$t('navigation.notifications')"
          >
            <i class="bx bx-bell" aria-hidden="true"></i>
            <span v-if="unreadCount" class="notification-badge">{{ unreadCount > 9 ? '9+' : unreadCount }}</span>
          </router-link>
        </div>

      </div>
    </div>
  </header>
</template>

<script>
import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { notificationService } from '@/services/notificationService';

export default {
  name: 'AppNavbar',
  props: {
    navigationOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['toggle-navigation'],
  setup(props, { emit }) {
    const unreadCount = ref(0);
    const menuButton = ref(null);
    watch(() => props.navigationOpen, async (open, wasOpen) => {
      if (open || !wasOpen) return;
      await nextTick();
      menuButton.value?.focus();
    });
    const onToggleNavigation = () => emit('toggle-navigation');

    const loadUnreadCount = async () => {
      try {
        const notifications = await notificationService.list();
        unreadCount.value = notifications.filter((notification) => !notification.read_at).length;
      } catch {
        unreadCount.value = 0;
      }
    };

    onMounted(() => {
      loadUnreadCount();
      window.addEventListener('notifications-updated', loadUnreadCount);
    });
    onBeforeUnmount(() => window.removeEventListener('notifications-updated', loadUnreadCount));

    return {
      unreadCount,
      menuButton,
      onToggleNavigation,
    };
  },
};
</script>

<style scoped>
.navbar-mobile-brand { display: none; }
.notification-link { position: fixed; top: 1rem; right: -6px; z-index: 12; display: grid; width: 42px; height: 40px; place-items: center; border: 1px solid rgba(255, 255, 255, .16); border-right: 0; border-radius: 11px 0 0 11px; background: #172238; box-shadow: 0 8px 24px rgba(0, 0, 0, .28); color: #8290a5; font-size: 1.15rem; text-decoration: none; transition: right .18s ease, width .18s ease, background .18s ease, color .18s ease; }
.notification-link:hover, .notification-link:focus-visible { right: 0; width: 47px; background: #202d47; color: #aab4c3; }
.notification-link.has-unread { color: #e6c84f; }
.notification-link.has-unread:hover, .notification-link.has-unread:focus-visible { color: #ffe16b; }
.notification-link > i { transform: translateX(-3px); transition: transform .18s ease; }
.notification-link:hover > i, .notification-link:focus-visible > i { transform: translateX(0); }
.notification-badge { position: absolute; top: 3px; right: 4px; display: grid; place-items: center; min-width: .9rem; height: .9rem; padding: 0 .18rem; border: 2px solid #172238; border-radius: 999px; background: #dc3545; color: #fff; font-size: .54rem; font-weight: 700; line-height: 1; }

@media (min-width: 769px) {
  .navbar { min-height: 0; padding: 0; border: 0; background: transparent; }
}

@media (max-width: 768px) {
  .navbar { flex-wrap: nowrap; }
  .navbar-mobile-brand { display: flex; min-width: 0; flex: 0 1 auto; align-items: center; gap: .5rem; color: #fff; font-size: 1.15rem; font-weight: 700; line-height: 1; text-decoration: none; white-space: nowrap; }
  .navbar-mobile-brand img { width: 34px; height: 34px; flex: 0 0 34px; object-fit: contain; }
  .navbar-mobile-brand span { display: inline-block; background: linear-gradient(135deg, hsl(291, 80%, 48%), hsl(328, 85%, 60%)); background-clip: text; color: transparent; transform: translateY(3px); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
  .nav-user-menu { width: auto !important; min-width: 0; flex: 1 1 0; }
  .notification-link { top: .5rem; }
}
</style>
